import { createPortal } from 'react-dom';
// ── VENUE POPUP ───────────────────────────────────────────────────────────────
function VenuePopup({ venue, equipment, onClose }) {
  // Nel body: aperto dalla vista serata, che ha un transform, il
  // position:fixed si aggancerebbe alla pagina e non allo schermo.
  return createPortal(
    <div className="popup-overlay" onClick={e=>e.target===e.currentTarget&&onClose()}>
      <div className="popup">
        <div style={{fontWeight:800,fontSize:19,marginBottom:4}}>{venue.name}</div>
        {venue.city&&<div style={{fontSize:16,color:"var(--muted)",marginBottom:8}}>{venue.city}{venue.address?` · ${venue.address}`:""}</div>}
        {venue.description&&<div style={{fontSize:16,color:"var(--muted)",marginBottom:10}}>{venue.description}</div>}
        {equipment.length>0&&<>
          <div style={{fontSize:16,fontWeight:700,color:"var(--muted)",textTransform:"uppercase",letterSpacing:".8px",marginBottom:6}}>Attrezzatura</div>
          <div className="chip-group" style={{marginBottom:10}}>
            {equipment.map(e=><span key={e.item} className="chip" style={{fontSize:16,background:"rgba(237,77,29,.08)",borderColor:"rgba(237,77,29,.25)",color:"var(--text)"}}>{e.item}</span>)}
          </div>
        </>}
        <button className="btn btn-secondary btn-sm" style={{width:"100%",justifyContent:"center"}} onClick={onClose}>Chiudi</button>
      </div>
    </div>,
    document.body
  );
}


export default VenuePopup;
